exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-skeleton[data-v-6bfa5e36]{background-color:rgba(0,0,0,.1);border-radius:12px;margin-bottom:20px}.bg-navy[data-v-6bfa5e36]{background-color:#1a2a6c}.animate-pulse[data-v-6bfa5e36]{-webkit-animation:pulse-data-v-6bfa5e36 1.5s ease-in-out infinite;animation:pulse-data-v-6bfa5e36 1.5s ease-in-out infinite}@-webkit-keyframes pulse-data-v-6bfa5e36{0%{opacity:1}50%{opacity:.5}to{opacity:1}}@keyframes pulse-data-v-6bfa5e36{0%{opacity:1}50%{opacity:.5}to{opacity:1}}", ""]);

// exports
